module.exports = {"countries":[{"name":"United States - FR","abbreviation":"USA - FR"},{"name":"Canada - FR","abbreviation":"CAN - FR"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/CountryOptions/locales/fr.json
// module id = 1178
// module chunks = 0